export default __webpack_public_path__ + "static/media/prev_arrow.736a619e.svg";